﻿(function ($) {
    $.fn.filterDropDown = function (options) {

        var settings = $.extend({
            parentDropDown: null,
            filterUrl: null,
            filterParam: "",
            filterNow: true,
            blankSelectionText: "--- Select a value ---",
            withGrouping: false
        }, options);

        function isArray() {
            return Array.isArray(settings.parentDropDown) && Array.isArray(settings.filterParam);
        }

        function getParents() {
            if (isArray()) {
                return settings.parentDropDown;
            } else {
                return [settings.parentDropDown];
            }
        }

        function getParamsNames() {
            if (isArray()) {
                return settings.filterParam;
            } else {
                return [settings.filterParam];
            }
        }

        function parentsHaveValue() {
            if (Array.isArray(settings.parentDropDown)) {
                var hasValues = true;
                var parents = getParents();
                for (var i = 0; i < parents.length; i++) {
                    if ((parents[i].val() == '0' || !parents[i])) {
                        hasValues = false;
                    }
                }
                return hasValues;
            } else {
                var parentValue = settings.parentDropDown.val();
                return !(parentValue == '0' || !parentValue);
            }
        }

        function getParams() {
            var params = {};
            var paramNames = getParamsNames();
            var parents = getParents();
            for (var i = 0; i < paramNames.length; i++) {
                params[paramNames[i]] = parents[i].val();
            }
            return params;
        }


        return this.each(function () {

            var childDropDown = $(this);
            var parents = getParents();

            /* Child drop-down should only be enabled if the parent drop-down has a value. */
            /* Also resets child to the default value when the parent is reset. */
            function setChildDropDown() {

                if (!parentsHaveValue()) {
                    Ahb.Utilities.clearDropDown(childDropDown);
                }
                else {
                    /* Repopulate child with options from call to server */

                    Ahb.Utilities.filterDropDown({
                        dropDown: childDropDown,
                        url: settings.filterUrl,
                        params: getParams(),
                        blankSelectionText: settings.blankSelectionText,
                        withGrouping: settings.withGrouping
                    });
                }
            }

            for (var i = 0; i < parents.length; i++) {
                console.log("Parents " + i, parents[i]);
                parents[i].change(function () {
                    setChildDropDown();
                    return true;
                });
            }

            /* Perform the filtering now if required */
            if (settings.filterNow) {
                setChildDropDown();
            }
        });
    };
}(jQuery));



//////////////////
// WEBPACK FOOTER
// ./Scripts/filtering.js
// module id = 554
// module chunks = 0